import "../../resources/less/Admin/Login/Login.less";
import "../../resources/less/components/LoginMessage.less";

class AdminLogin {
  constructor() {}
}

$(window).on("load", () => {
  new AdminLogin();
});
